import { useEffect, useState } from "react";
import { Alert, DatePicker, Modal, message } from "antd";
import dayjs from "dayjs";
import { collectionAPIWithErrorHandling } from "../../../api/collection/collection";
import { neutral } from "../../../theme/tokens";

/**
 * Đợt thu đang hoạt động đã quá ngày kết thúc → được gia hạn giao dịch thanh toán.
 * Đợt con không có nút: gia hạn một lần ở đợt cha. Luật trùng với
 * CollectionService::extendPaymentExpiry ở backend.
 */
export const canExtendPayment = (collection) =>
  !!collection &&
  !collection.parent_id &&
  collection.status === "ONGOING" &&
  !!collection.end_date &&
  dayjs(collection.end_date).isBefore(dayjs(), "day");

/**
 * Gia hạn giao dịch thanh toán: chọn hạn mới (sau hôm nay). Backend lưu hạn, hủy mã cũ của
 * khoản chưa thanh toán; mã mới mang hạn mới tự tạo khi gửi tin hoặc in phiếu. Thông tin
 * đợt thu (ngày kết thúc, hạn trong tin nhắn) giữ nguyên.
 */
const ExtendPaymentDialog = ({ open, collection, onClose, onDone }) => {
  const [date, setDate] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) setDate(dayjs().add(7, "day"));
  }, [open]);

  const handleOk = async () => {
    setSubmitting(true);
    try {
      const res = await collectionAPIWithErrorHandling.extendPayment(
        collection.id,
        date.format("YYYY-MM-DD")
      );
      message.success(res.data?.message || "Đã gia hạn giao dịch thanh toán");
      onDone?.();
      onClose();
    } catch (error) {
      message.error(error.message || "Không gia hạn được giao dịch thanh toán");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Gia hạn giao dịch thanh toán"
      okText="Gia hạn"
      cancelText="Hủy"
      onOk={handleOk}
      onCancel={onClose}
      okButtonProps={{ disabled: !date }}
      confirmLoading={submitting}
      destroyOnClose
      width="min(480px, 100vw)"
    >
      <div style={{ fontSize: 13, color: neutral[600], marginBottom: 6 }}>Hạn giao dịch mới</div>
      <DatePicker
        value={date}
        onChange={setDate}
        format="DD/MM/YYYY"
        allowClear={false}
        disabledDate={(d) => !d.isAfter(dayjs(), "day")}
        style={{ width: "100%" }}
      />
      <Alert
        type="info"
        showIcon
        style={{ marginTop: 16 }}
        message="Mã thanh toán của các khoản chưa thanh toán sẽ được hủy và cấp lại với hạn mới khi gửi tin hoặc in phiếu."
        description={
          // Đợt cha thật không gắn đơn vị; đợt nhân sự tự tạo cũng là PARENT nhưng có đơn vị, không có con
          collection?.type_child === "PARENT" && !collection?.organization_id
            ? "Áp dụng cho tất cả đợt con. Ngày kết thúc và nội dung đợt thu không thay đổi."
            : "Ngày kết thúc và nội dung đợt thu không thay đổi."
        }
      />
    </Modal>
  );
};

export default ExtendPaymentDialog;
